import SelectDinamico from "../../SelectDinamico";
import ConsultaCondPagto from "../../../../lib/json/consultas/CondicaoPagamento.json"

function SelectCondicaoPagamento({campoCondPagto, changeCondPagto, queryCondPagto, disabled = false, empresaLogada, returnOriginal = false, loadDefault = true, showLabel = true, bindItem, field}){
    const empresaFilial = empresaLogada || localStorage.getItem('empresaFilial')
    const cConsultaDefault = ConsultaCondPagto.consulta + " WHERE D_E_L_E_T_ <> '*' AND E4_FILIAL = FILIAL(SE4) AND E4_MSBLQL != 1 "
    const consulta = queryCondPagto || ( loadDefault ? cConsultaDefault : '' )
    const condPagtoValue = bindItem ? bindItem[field] : campoCondPagto;

    return (
        <SelectDinamico
            label={showLabel ? "Condição Pagamento" : undefined}
            cText="E4_CODIGO + ' - ' + item.E4_DESCRI"
            cValue="E4_CODIGO"
            campoValue={condPagtoValue}
            consulta={consulta}
            tabela={ConsultaCondPagto.tabelas}
            isMultiplo={false}
            showNoFilter={false}
            EmpresaLogada={empresaFilial}
            onchange={(e) => changeCondPagto(e)}
            returnOrigem={returnOriginal}
            bindItem={bindItem}
            field={field}
            disabled={disabled}
        />
    )
}

export default SelectCondicaoPagamento;